import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=ca55b35c&scoped=true&"
import script from "./Job.vue?vue&type=script&lang=js&"
export * from "./Job.vue?vue&type=script&lang=js&"
import style0 from "./Job.vue?vue&type=style&index=0&id=ca55b35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca55b35c",
  null
  
)

export default component.exports